module.exports = __webpack_public_path__ + "img/9_f.9d5bf1d0.jpg";